export { default } from './check'
